import type { PropsWithChildren } from "react";

import { Divider, Heading } from "@/ui";

type ResearchTagProps = {
  title: string;
};

export const ResearchTag = ({ children, title }: PropsWithChildren<ResearchTagProps>) => {
  return (
    <div className="flex items-center justify-start">
      <Divider.Line className="w-14" />

      <div className="mr-auto flex flex-col rounded-xl border bg-surface p-3">
        <Heading className="text-base font-bold" level={5}>
          {title}
        </Heading>

        <div>{children}</div>
      </div>
    </div>
  );
};
